import styled from 'styled-components';

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #ff780c;
  border-radius: 15px;
  width: 100%;
  min-height: 3.5rem;
  padding: 0.75rem 1.3rem;
  gap: 0.6rem;
  background-color: #ffffff;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08),
    0 1.5px 4px 0 rgba(0, 0, 0, 0.05);

  break-inside: avoid;
  page-break-inside: avoid;
`;

export const TitleField = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

export const Text = styled.span`
  word-break: break-word;
  white-space: pre-line;
  overflow-wrap: break-word;
  display: block;
  font-family: 'Roboto', sans-serif;
  font-size: clamp(11px, 0.9vw, 14px);
`;

export const OptionsField = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
`;

export const OptionChip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 0.25rem 0.9rem;
  min-height: 2rem;
  background-color: #ff780c;

  span {
    color: #ffffff;
    font-weight: 600;
    text-align: center;
  }
`;
